import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import SummarizeModal from '@/proofreading/phase2/summarize-modal.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import ReasonExampleDialog from '@/components/yagiprime/ReasonExampleDialog.vue'
import ReasonProofreadTipsDialog from '@/components/yagiprime/ReasonProofreadTipsDialog.vue'
import ReasonAiMyprForm from '@/components/yagiprime/ReasonAiMyprForm.vue'
import ReasonAiMyprPanel from '@/components/yagiprime/ReasonAiMyprPanel.vue'
import ReasonSummarizePreview from '@/components/yagiprime/ReasonSummarizePreview.vue'
import { useReasonAiMypr } from '@/composables/yagiprime/useReasonAiMypr'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonCard',
  props: {
    formatId: null,
    exampleSentences: null,
    textareaMinRows: null,
    previewErrors: null,
    formatData: null,
    currentCardId: null
  },
  emits: ["update:reason", "update-format-field"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:reason', value: string): void
  (e: 'update-format-field', payload: { key: string; value: unknown }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formatId: string
  exampleSentences: { reason?: Array<{ title: string; description: string }> }
  textareaMinRows: number
  previewErrors: Record<string, unknown>
  formatData: Record<string, unknown>
  currentCardId: string
};





function updateFormatField(key: string, value: unknown) {
  emit('update-format-field', { key, value })
}

function onUpdateField(payload: { key: string; value: unknown }) {
  updateFormatField(payload.key, payload.value)
}

const api = useReasonAiMypr({
  formatData: props.formatData,
  emit,
  updateFormatField
})

const {
  globalVar,
  isAuthenticated,
  aiMyprVisible,
  closeAiMyprDialog,
  openLoginDialog,
  aiResultView,
  aiResultMyprResult,
  fullscreenLoading,
  loadingText,
  aiGeneratedExampleReason,
  hopeIndustryOptions,
  hopeCareerJobcategoryOptions,
  isSendMail,
  aiUsageCount,
  aiMaxUsageCount,
  isExtractingCompanyInfo,
  isCompanyInfoExtracted,
  exampleDialogVisible,
  tipsDialogVisible,
  summarizeModalVisible,
  summarizePreview,
  aiIsStreaming,
  aiIsThinking,
  aiThinkingLabel,
  aiReasoningText,
  aiShowReasoning,
  toggleAiReasoning,
  reason,
  getLicences,
  aiMyprCtaState,
  summarizeTargetLength,
  summarizePreviewFirst,
  summarizePreviewDisplayText,
  reasonClear,
  updateReason,
  showModalFromNewAi,
  toggleAIMyprDialog,
  extractCompanyInfo,
  handleAIMypr,
  goYagiprimeRegister,
  applyAiMyprResult,
  openSummarizeModal,
  applySummarize,
  closeSummarizePreview,
  openYagiprimeFromPreview,
  applySummarizePreview,
  showYagiprimeForSummarize,
  insertSentence
} = api

function onAiMyprVisible(val: boolean) {
  if (!val) closeAiMyprDialog()
  else aiMyprVisible.value = true
}

const reasonLabels = {
  default:
    '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
  jobNew:
    '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
  jobNewSingle:
    '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
  reasonLabel20240717:
    '志望動機を入力してください。 1日1回、無料でAIで文章を生成することができます。\nヤギプライムに加入すると、文章生成が1日10回に上限解放されます。',
  reasonLabelYagiprime: '最新のAIを使って、あなたらしい文章にしましょう！'
}

const reasonLabel = computed(() => {
  if (props.formatId === 'rirekisho_job_new') return reasonLabels.jobNew
  if (props.formatId === 'rirekisho_job_new_single') {
    return reasonLabels.jobNewSingle
  }
  return reasonLabels.default
})
const reasonLabel20240717 = reasonLabels.reasonLabel20240717
const reasonLabelYagiprime = reasonLabels.reasonLabelYagiprime

const legacyReasonLabelFormatIds = [
  'rirekisho_job_change_old',
  'rirekisho_job_change2',
  'rirekisho_single',
  'rirekisho_nophoto_double',
  'rirekisho_nophoto'
] as const

const showReasonLabel20240717 = computed(
  () =>
    !(legacyReasonLabelFormatIds as readonly string[]).includes(props.formatId)
)
const reasonAutosizeSettings = computed(() => {
  const baseRows =
    props.formatId === 'rirekisho_job_change' ? 7 : props.textareaMinRows
  const minRows = Math.max(1, baseRows * 2)
  return { minRows, maxRows: Math.max(minRows, 20) }
})

return { __sfc: true,props, emit, updateFormatField, onUpdateField, api, globalVar, isAuthenticated, aiMyprVisible, closeAiMyprDialog, openLoginDialog, aiResultView, aiResultMyprResult, fullscreenLoading, loadingText, aiGeneratedExampleReason, hopeIndustryOptions, hopeCareerJobcategoryOptions, isSendMail, aiUsageCount, aiMaxUsageCount, isExtractingCompanyInfo, isCompanyInfoExtracted, exampleDialogVisible, tipsDialogVisible, summarizeModalVisible, summarizePreview, aiIsStreaming, aiIsThinking, aiThinkingLabel, aiReasoningText, aiShowReasoning, toggleAiReasoning, reason, getLicences, aiMyprCtaState, summarizeTargetLength, summarizePreviewFirst, summarizePreviewDisplayText, reasonClear, updateReason, showModalFromNewAi, toggleAIMyprDialog, extractCompanyInfo, handleAIMypr, goYagiprimeRegister, applyAiMyprResult, openSummarizeModal, applySummarize, closeSummarizePreview, openYagiprimeFromPreview, applySummarizePreview, showYagiprimeForSummarize, insertSentence, onAiMyprVisible, reasonLabels, reasonLabel, reasonLabel20240717, reasonLabelYagiprime, legacyReasonLabelFormatIds, showReasonLabel20240717, reasonAutosizeSettings, SummarizeModal, AiMyprDialog, ReasonExampleDialog, ReasonProofreadTipsDialog, ReasonAiMyprForm, ReasonAiMyprPanel, ReasonSummarizePreview }
}

})